import { errors } from "../config/errors";

  export const administrationErrorsDetection = (data) => {
    return errors.administrationErrorsDetection(data).then(response => response)
  };